import { transparentize } from 'polished'
import styled from 'styled-components'

export const LoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => transparentize(0.8, theme['gray-100'])};
`
